import { render, staticRenderFns } from "./hotzone.vue?vue&type=template&id=5bf93774&scoped=true"
import script from "./hotzone.vue?vue&type=script&lang=ts"
export * from "./hotzone.vue?vue&type=script&lang=ts"
import style0 from "./hotzone.vue?vue&type=style&index=0&id=5bf93774&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf93774",
  null
  
)

export default component.exports